import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import SubscriberActions from "../../../../Redux/transition/subscriber/subscriber.reducer";
import { Button } from "primereact/button";
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { InputText } from "primereact/inputtext";
import { FormatCurrency, useCurrencyConstants } from "../../../../Components/CurrencyFormatter";
import { useTranslation } from "react-i18next";
import DefMembershipActions from "../../../../Redux/actions/defMembership-actions";
import PaymentTrackActions from "../../../../Redux/transition/payment-track/payment-track.reducer";
import PaymentScheduleActions from "../../../../Redux/transition/payment-schedule/payment-schedule.reducer";
import { useParams } from "react-router-dom";
import Loading from "../../../../Components/Loading"
import "../../../../Styles/pages/subscriptions.scss"
import "../../../../Styles/pages/product.scss"
import DetailCard from "./DetailCard";
import TransactionsTabs from './TransactionsTabs'
import { useDateFormatter } from "../../../../Components/FormatDateTime";
import CollectPayment from "../../../Customers/collectPayment";
import RecordPayment from "../../../Customers/recordPayment";
import { TreeSelectComponent } from "../../../../Components/TreeSelectComponent";
import PlanGroupActions from "../../../../Redux/transition/plan-group/plan-group.reducer";

const REASSIGNABLE_SCHEDULE_STATUSES = ["EXTERNALLY_RECEIVED", "COMPLETED"];

const toScheduleList = (schedules) => {
	if (!schedules) return [];
	const plain = typeof schedules.asMutable === "function" ? schedules.asMutable({ deep: true }) : schedules;
	if (Array.isArray(plain)) return plain;
	if (Array.isArray(plain.content)) return plain.content;
	return [];
};

const resolveReassignSchedule = (schedules) => {
	const list = toScheduleList(schedules);
	if (list.length === 0) return null;
	if (list.length === 1) return list[0];
	const eligible = list.filter((schedule) => REASSIGNABLE_SCHEDULE_STATUSES.includes(schedule?.status));
	return eligible[0] || list[0];
};

const getApiErrorDetail = (error, fallback) => {
	if (!error) return fallback;
	if (error.detail || error.message || error.title) {
		return error.detail || error.message || error.title;
	}
	if (typeof error === "string") return error;
	return fallback;
};

// NB: anything marking or mark is related to marking a payment as externally received 
// i.e. recording a payment received through any payment method other than Reveknew's known payment channel as received
const Subscribers = (props) => {

	const { formatApiDate } = useDateFormatter();
	const { currencyFormat, currencySymbol } = useCurrencyConstants();

	const { t } = useTranslation("common");
	const cancelToast = useRef(null)
	const pauseToast = useRef(null)
	const resumeToast = useRef(null)
	const rescheduleToast = useRef(null)
	const reassignToast = useRef(null)
	const changeTargetToast = useRef(null)
	const [confirmPause, setConfirmPause] = useState(false)
	const [confirmResume, setConfirmResume] = useState(false)
	const [confirmCancel, setConfirmCancel] = useState(false)
	const [confirmReschedule, setConfirmReschedule] = useState(false)
	const [confirmReassign, setConfirmReassign] = useState(false)
	const [confirmChangeTarget, setConfirmChangeTarget] = useState(false)
	const [changeTargetRequested, setChangeTargetRequested] = useState(false)
	const [newTarget, setNewTarget] = useState("")
	const [reassignRequested, setReassignRequested] = useState(false)
	const [reassignDialog, setReassignDialog] = useState({
		treePlanSelectedKey: null,
		treePlanSelected: null,
		treeProductSelected: null,
	});
	const [date, setDate] = useState(null);
	const [state, setState] = useState({
		subscriberObjects: {},
		paymentTracks: [],
		missedSchedules: [],
		scheduleId: null,
		date: null,
		paymentData: [],
		marking: true,
		cancelled: false,
		response: null,
		paused: false,
		missedPaymentCount: null,
		resumed: false,
		rescheduled: false,
		paymentSchedulesObjects: null,
		key: false,
		page: 0,
		size: 15,
		sort: 'receivedAt,desc',
		sortOrder: 'id,desc',
		showToast: false,
		subsExternalPayments: [],
		missedSchedulesCount: null,
		count: null,
		revenueObject: {},
		subscriptionSummary: {},
		showCollectPopup: false,
		showRecordPopup: false,
		currentSubscription: null,
		paymentScheduleId: null,
		onSubscriptionsTable: false,
	});

	let today = new Date();

	let { id } = useParams();

	const defMembership = useSelector((state) => state.defMembership.defMembership)
	const paymentSchedules = useSelector((state) => state.paymentSchedules.paymentSchedules)
	const paymentSchedulesMissed = useSelector((state) => state.paymentSchedules.paymentSchedulesMissed)
	const fetchingSchedule = useSelector((state) => state.paymentSchedules.fetchingSchedule)
	const paymentTracks = useSelector((state) => state.paymentTracks.paymentTracks)
	const fetchingTracks = useSelector((state) => state.paymentTracks.fetchingTracks)
	const subscriber = useSelector((state) => state.subscribers.subscriber)
	const fetchingSubscriber = useSelector((state) => state.subscribers.fetchingOne)
	const missedPaymentCount = useSelector((state) => state.paymentSchedules.missedPaymentSchedulesCount)
	const cancelledSubscription = useSelector((state) => state.subscribers.cancelledSubscription)
	const cancellingSubscription = useSelector((state) => state.subscribers.cancellingSubscription)
	const pausingSubscription = useSelector((state) => state.subscribers.pausingSubscription)
	const pausedSubscription = useSelector((state) => state.subscribers.pausedSubscription)
	const resumingSubscription = useSelector((state) => state.subscribers.resumingSubscription)
	const resumedSubscription = useSelector((state) => state.subscribers.resumedSubscription)
	const rescheduledSubscription = useSelector((state) => state.subscribers.rescheduledSubscription)
	const reschedulingSubscription = useSelector((state) => state.subscribers.reschedulingSubscription)
	const subsPayments = useSelector((state) => state.paymentTracks.subsPayments)
	const paymentTracksCount = useSelector((state) => state.paymentTracks.paymentTracksCount)
	const missedPaymentSchedulesCount = useSelector((state) => state.paymentSchedules.missedPaymentSchedulesCount)
	const subscriberRevenue = useSelector((state) => state.subscribers.subscriberRevenue)
	const subscriptionSummary = useSelector((state) => state.subscribers.subscriptionSummary)
	const recentPendingPaymentSchedule = useSelector((state) => state.paymentSchedules.recentPendingPaymentSchedule)
	const fetchingAllPaymentSchedules = useSelector((state) => state.paymentSchedules.fetchingAll)
	const reassigningPaymentSchedulePlan = useSelector((state) => state.paymentSchedules.reassigningPaymentSchedulePlan)
	const reassignedPaymentSchedule = useSelector((state) => state.paymentSchedules.reassignedPaymentSchedule)
	const errorReassigningPaymentSchedulePlan = useSelector((state) => state.paymentSchedules.errorReassigningPaymentSchedulePlan)
	const planGroupsGraphedActive = useSelector((state) => state.planGroups.planGroupsGraphedActive)
	const changingSubscriptionTarget = useSelector((state) => state.subscribers.changingSubscriptionTarget)
	const changedSubscriptionTarget = useSelector((state) => state.subscribers.changedSubscriptionTarget)
	const errorChangingSubscriptionTarget = useSelector((state) => state.subscribers.errorChangingSubscriptionTarget)

	const dispatch = useDispatch()
	const getSubscriber = useCallback((subscriberId) => { dispatch(SubscriberActions.subscriberRequest(subscriberId)) }, [dispatch])
	const getMembership = useCallback((subscriberId) => { dispatch(DefMembershipActions.defMembershipRequest()) }, [dispatch])
	// const getMissedPaymentSchedulesCount = useCallback((subscriberId, options) => { dispatch(PaymentScheduleActions.missedPaymentSchedulesCountRequest(subscriberId, options)) }, [dispatch])
	const getAllPaymentSchedules = useCallback((subscriberId, options) => { dispatch(PaymentScheduleActions.paymentScheduleAllRequest(subscriberId, options)) }, [dispatch])
	const getAllPaymentTracks = useCallback((subscriberId, options) => { dispatch(PaymentTrackActions.paymentTrackAllRequest(subscriberId, options)) }, [dispatch])
	const getAllPaymentTracksCount = useCallback((subscriberId, options) => { dispatch(PaymentTrackActions.paymentTracksCountRequest(subscriberId, options)) }, [dispatch])
	const cancelSubscriptions = useCallback((subscriptionId, membershipId) => { dispatch(SubscriberActions.cancelSubscriptionRequest(subscriptionId, membershipId)) }, [dispatch])
	const pauseSubscriptions = useCallback((subscriptionId, membershipId) => { dispatch(SubscriberActions.pauseSubscriptionRequest(subscriptionId, membershipId)) }, [dispatch])
	const resumeSubscriptions = useCallback((id, startFrom, membershipId, action) => { dispatch(SubscriberActions.resumeSubscriptionRequest(id, startFrom, membershipId, action)) }, [dispatch])
	const rescheduleSubscriptions = useCallback((subscriberId, startFrom, membershipId) => { dispatch(SubscriberActions.rescheduleSubscriptionRequest(subscriberId, startFrom, membershipId)) }, [dispatch])
	const getMissedPaymentSchedulesCount = useCallback((subscriberId, options) => { dispatch(PaymentScheduleActions.missedPaymentSchedulesCountRequest(subscriberId, options)) }, [dispatch])
	const getTotalSubscriberRevenue = useCallback((subscriberId) => { dispatch(SubscriberActions.subscriberRevenueRequest(subscriberId)) }, [dispatch])
	const getSubscriptionSummary = useCallback((subscriptionId) => { dispatch(SubscriberActions.subscriptionSummaryRequest(subscriptionId)) }, [dispatch])
	const getRecentPendingPaymentSchedule = useCallback((subscriptionId) => { dispatch(PaymentScheduleActions.recentPendingPaymentScheduleRequest(subscriptionId)) }, [dispatch])
	const reassignPaymentSchedulePlan = useCallback((paymentScheduleId, planId, membershipId) => {
		dispatch(PaymentScheduleActions.reassignPaymentSchedulePlanRequest(paymentScheduleId, planId, membershipId))
	}, [dispatch])
	const getActivePlanGroups = useCallback((businessId) => { dispatch(PlanGroupActions.planGroupGraphedActiveRequest(businessId)) }, [dispatch])
	const changeSubscriptionTarget = useCallback((subscriptionId, membershipId, amount) => {
		dispatch(SubscriberActions.changeSubscriptionTargetRequest(subscriptionId, membershipId, amount))
	}, [dispatch])

	const membershipId = defMembership?.id;
	const countryCurrency = defMembership?.business?.country?.currency;

	const isScheduledForToday = useCallback((scheduledFor) => {
		if (!scheduledFor) return false;
		return formatApiDate(scheduledFor) === formatApiDate(new Date());
	}, [formatApiDate]);

	const showTriggerPayment = useMemo(() => {
		const sub = state.subscriberObjects;
		const schedule = recentPendingPaymentSchedule;
		return sub?.status === "ACTIVE"
			&& ["FIXED", "FLEXIBLE"].includes(sub?.plan?.policy)
			&& schedule?.status === "PENDING"
			&& isScheduledForToday(schedule?.scheduledFor);
	}, [state.subscriberObjects, recentPendingPaymentSchedule, isScheduledForToday]);

	const showRecordPayment = useMemo(() => {
		const sub = state.subscriberObjects;
		return sub?.status === "ACTIVE"
			&& ["FIXED", "FLEXIBLE"].includes(sub?.plan?.policy)
			&& sub?.plan?.billingPeriod === "ONCE";
	}, [state.subscriberObjects]);

	const showReassignPlan = useMemo(() => {
		const sub = state.subscriberObjects;
		return sub?.status === "COMPLETE"
			&& sub?.plan?.billingPeriod === "ONCE";
	}, [state.subscriberObjects]);

	const showChangeTarget = useMemo(() => {
		const sub = state.subscriberObjects;
		const isVariableTarget = Boolean(
			sub?.plan?.flexibleTarget
			|| (sub?.plan?.policy === "TARGET" && sub?.plan?.targetEqualParts === false)
		);
		return isVariableTarget && !["CANCELLED", "COMPLETE"].includes(sub?.status);
	}, [state.subscriberObjects]);

	const collectedTargetAmount = Number(
		subscriptionSummary?.collectedAmount ?? state.subscriberObjects?.collected ?? 0
	) || 0;
	const currentTargetAmount = Number(state.subscriberObjects?.target);
	const minTargetAmount = Math.max(1, collectedTargetAmount);
	const formattedMinTarget = FormatCurrency({
		amount: minTargetAmount,
		currencySymbol,
		currencyFormat,
		as: "string",
	});
	const parsedNewTarget = newTarget === "" ? null : Number(newTarget);
	const changeTargetUnchanged = parsedNewTarget != null && parsedNewTarget === currentTargetAmount;
	const changeTargetTooLow = parsedNewTarget != null && parsedNewTarget < minTargetAmount;
	const canSubmitChangeTarget = parsedNewTarget != null
		&& !Number.isNaN(parsedNewTarget)
		&& parsedNewTarget >= minTargetAmount
		&& !changeTargetUnchanged
		&& !changingSubscriptionTarget
		&& Boolean(defMembership?.id);

	const reassignableSchedule = useMemo(
		() => resolveReassignSchedule(paymentSchedules),
		[paymentSchedules]
	);

	const hasOtherOncePlans = useMemo(() => {
		const currentPlanId = state.subscriberObjects?.plan?.id;
		const groups = planGroupsGraphedActive?.groups || [];
		return groups.some((groupItem) =>
			(groupItem?.plans || []).some((plan) =>
				String(plan?.billingPeriod || "").includes("ONCE")
				&& ["FIXED", "FLEXIBLE"].includes(plan?.policy)
				&& !String(plan?.status || "").includes("ARCHIVED")
				&& (currentPlanId == null || String(plan?.id) !== String(currentPlanId))
			)
		);
	}, [planGroupsGraphedActive, state.subscriberObjects?.plan?.id]);

	const buildCurrentSubscriptionForCollect = useCallback((subscriber, paymentScheduleId) => ({
		id: subscriber.id,
		businessCustomer: subscriber.businessCustomer,
		subscriber: { plan: subscriber.plan },
		status: subscriber.status,
		paymentScheduleId,
	}), []);

	const openTriggerPayment = useCallback(() => {
		const subscriber = state.subscriberObjects;
		const schedule = recentPendingPaymentSchedule;
		if (!subscriber || !schedule?.id) return;

		setState((prev) => ({
			...prev,
			showCollectPopup: true,
			paymentScheduleId: schedule.id,
			currentSubscription: buildCurrentSubscriptionForCollect(subscriber, schedule.id),
		}));
	}, [state.subscriberObjects, recentPendingPaymentSchedule, buildCurrentSubscriptionForCollect]);

	const openRecordPayment = useCallback(() => {
		const subscriber = state.subscriberObjects;
		if (!subscriber?.id) return;

		setState((prev) => ({
			...prev,
			showRecordPopup: true,
			onSubscriptionsTable: true,
			currentSubscription: buildCurrentSubscriptionForCollect(subscriber),
		}));
	}, [state.subscriberObjects, buildCurrentSubscriptionForCollect]);

	const closeReassignDialog = useCallback(() => {
		if (reassigningPaymentSchedulePlan) return;
		setConfirmReassign(false);
		setReassignRequested(false);
		setReassignDialog({
			treePlanSelectedKey: null,
			treePlanSelected: null,
			treeProductSelected: null,
		});
	}, [reassigningPaymentSchedulePlan]);

	const openReassignPlan = useCallback(() => {
		setReassignDialog({
			treePlanSelectedKey: null,
			treePlanSelected: null,
			treeProductSelected: null,
		});
		setReassignRequested(false);
		setConfirmReassign(true);
	}, []);

	const closeChangeTargetDialog = useCallback(() => {
		if (changingSubscriptionTarget) return;
		setConfirmChangeTarget(false);
		setChangeTargetRequested(false);
		setNewTarget("");
	}, [changingSubscriptionTarget]);

	const openChangeTarget = useCallback(() => {
		setNewTarget("");
		setChangeTargetRequested(false);
		setConfirmChangeTarget(true);
	}, []);

	const refreshSubscriptionDetail = useCallback(() => {
		getSubscriber(id);
		getAllPaymentTracks(id, { page: state.page, sort: state.sort, size: state.size });
		getAllPaymentTracksCount(id);
		getMissedPaymentSchedulesCount(id, { page: state.page, sort: state.sortOrder, size: state.size });
		getTotalSubscriberRevenue(id);
		getSubscriptionSummary(id);
		if (state.subscriberObjects?.status === "ACTIVE") {
			getRecentPendingPaymentSchedule(id);
		}
	}, [
		getSubscriber,
		getAllPaymentTracks,
		getAllPaymentTracksCount,
		getMissedPaymentSchedulesCount,
		getTotalSubscriberRevenue,
		getSubscriptionSummary,
		getRecentPendingPaymentSchedule,
		id,
		state.page,
		state.sort,
		state.size,
		state.sortOrder,
		state.subscriberObjects?.status,
	]);
	useEffect(() => {
		getSubscriber(id)
		getAllPaymentTracks(id, { page: state.page, sort: state.sort, size: state.size });
		getAllPaymentTracksCount(id);
		getMissedPaymentSchedulesCount(id, { page: state.page, sort: state.sortOrder, size: state.size });
		// getMissedPaymentSchedulesCount(id, { page: state.page, sort: state.sortOrder, size: state.size })
		getTotalSubscriberRevenue(id)
		getSubscriptionSummary(id)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (subscriber?.status === "ACTIVE") {
			getRecentPendingPaymentSchedule(id);
		}
	}, [subscriber?.status, id, getRecentPendingPaymentSchedule]);

	useEffect(() => {
		if (!confirmReassign || !id) return;
		getAllPaymentSchedules(id);
	}, [confirmReassign, id, getAllPaymentSchedules]);

	useEffect(() => {
		if (!confirmReassign) return;
		if (defMembership?.business?.id && !planGroupsGraphedActive) {
			getActivePlanGroups(defMembership.business.id);
		}
	}, [confirmReassign, defMembership?.business?.id, planGroupsGraphedActive, getActivePlanGroups]);

	//Handle side effects (aka: componentDidUpdate)
	useEffect(() => {

		if (!defMembership) {
			getMembership();
		}
		if (subscriber) {
			setState((state) => { return { ...state, subscriberObjects: subscriber } })
		}

		/* Setting the state of the paymentTracks to the paymentTracks from the redux store. */
		if (paymentTracks) {
			setState((state) => { return { ...state, paymentTracks } })
		}
		if (paymentSchedulesMissed) {
			setState((state) => { return { ...state, missedSchedules: paymentSchedulesMissed } })
		}
		if (paymentSchedules) {
			setState((state) => { return { ...state, paymentSchedulesObjects: paymentSchedules } })
		}
		if (missedPaymentCount) {
			setState((state) => ({ ...state, missedPaymentCount }))
		}
		if (subsPayments) {
			setState((state) => { return { ...state, subsExternalPayments: subsPayments.content } })
		}
		if (missedPaymentSchedulesCount) {
			setState((state) => { return { ...state, missedSchedulesCount: missedPaymentSchedulesCount } })
		}
		if (paymentTracksCount) {
			setState((state) => { return { ...state, count: paymentTracksCount } })
		}
		if (subscriberRevenue) {
			setState((state) => { return { ...state, revenueObject: subscriberRevenue } })
		}
		if (subscriptionSummary) {
			setState((state) => { return { ...state, subscriptionSummary: subscriptionSummary } })
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [defMembership, subscriber, paymentSchedules, subsPayments,
		state.subsExternalPayments, missedPaymentSchedulesCount, paymentTracksCount, missedPaymentCount, subscriberRevenue, subscriptionSummary]);


	useEffect(() => {
		if (!cancellingSubscription && state.key && state.cancelled) {
			setConfirmCancel(false)
			setState((state) => { return { ...state, cancelled: false, key: false, response: cancelledSubscription, showToast: true } })
			cancelSuccess()
		}
		if (!pausingSubscription && pausedSubscription && state.paused) {
			pauseSuccess()
			setConfirmPause(false)
			setState((state) => { return { ...state, paused: false } })
		}
		if (!resumingSubscription && state.key && state.resumed) {
			setConfirmResume(false)
			setState((state) => { return { ...state, resumed: false, key: false } })
			resumeSuccess()
		}
		if (!reschedulingSubscription && state.key && state.rescheduled) {
			setConfirmReschedule(false)
			setState((state) => { return { ...state, rescheduled: false, key: false } })
			rescheduleSuccess()
		}
		if (reassignRequested && !reassigningPaymentSchedulePlan) {
			if (reassignedPaymentSchedule) {
				setConfirmReassign(false)
				setReassignRequested(false)
				setReassignDialog({
					treePlanSelectedKey: null,
					treePlanSelected: null,
					treeProductSelected: null,
				});
				reassignSuccess()
			} else if (errorReassigningPaymentSchedulePlan) {
				setReassignRequested(false)
				reassignFailure(errorReassigningPaymentSchedulePlan)
			}
		}
		if (changeTargetRequested && !changingSubscriptionTarget) {
			if (changedSubscriptionTarget) {
				setConfirmChangeTarget(false)
				setChangeTargetRequested(false)
				setNewTarget("")
				changeTargetSuccess()
			} else if (errorChangingSubscriptionTarget) {
				setChangeTargetRequested(false)
				changeTargetFailure(errorChangingSubscriptionTarget)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cancellingSubscription, state.cancelled, state.key,
		pausingSubscription, pausedSubscription, state.paused, resumingSubscription, resumedSubscription, state.resumed,
		reschedulingSubscription, state.rescheduled, rescheduledSubscription,
		reassignRequested, reassigningPaymentSchedulePlan, reassignedPaymentSchedule, errorReassigningPaymentSchedulePlan,
		changeTargetRequested, changingSubscriptionTarget, changedSubscriptionTarget, errorChangingSubscriptionTarget
	])

	const loading = fetchingSchedule || fetchingTracks || fetchingSubscriber

	// toast for when a subscription is cancelled successfully
	const cancelSuccess = () => {
		cancelToast.current.show({ severity: 'success', summary: t('success'), detail: t('subscriber.cancelled'), life: 3000 })
	}

	// toast for when a subscription is paused successfully
	const pauseSuccess = () => {
		pauseToast.current.show({ severity: 'success', summary: t('success'), detail: t('subscriber.paused'), life: 3000 })
	}

	// toast for when a subscription is resumed successfully
	const resumeSuccess = () => {
		resumeToast.current.show({ severity: 'success', summary: t('success'), detail: t('subscriber.resumed'), life: 3000 })
	}

	// toast for when a subscription is rescheduled successfully
	const rescheduleSuccess = () => {
		rescheduleToast.current.show({ severity: 'success', summary: t('success'), detail: t('subscriber.rescheduled'), life: 3000 })
	}

	const reassignSuccess = () => {
		reassignToast.current.show({ severity: 'success', summary: t('success'), detail: t('subscriber.reassign_plan_success'), life: 3000 })
	}

	const reassignFailure = (error) => {
		reassignToast.current.show({
			severity: 'error',
			summary: t('failed'),
			detail: getApiErrorDetail(error, t('subscriber.reassign_plan_failed')),
			life: 4000,
		})
	}

	const changeTargetSuccess = () => {
		changeTargetToast.current.show({ severity: 'success', summary: t('success'), detail: t('subscriber.change_target_success'), life: 3000 })
	}

	const changeTargetFailure = (error) => {
		changeTargetToast.current.show({
			severity: 'error',
			summary: t('failed'),
			detail: getApiErrorDetail(error, t('subscriber.change_target_failed')),
			life: 4000,
		})
	}

	const newDate = formatApiDate(date);

	const footerContent = (
		<div className="subs-actions-footer">
			<Button label={t('subscriber.cancel')} icon="pi pi-times" className="p-button-text" id="resume_no_btn"
				onClick={() => { setConfirmResume(false) }}
			/>
			<Button label={t('subscriber.resume')} icon="pi pi-check" loading={resumingSubscription} disabled={!date} id="resumeSubs_yes_btn"
				onClick={() => {
					resumeSubscriptions(id, newDate, defMembership.id, "RESUME")
					setState((state) => { return { ...state, resumed: true, key: true } })
				}}
				autoFocus />
		</div>
	);

	const pauseSubscriptionActions = (
		<div className="subs-actions-footer">
			<Button label={t('subscriber.cancel')} icon="pi pi-times" id="pause_no_btn"
				onClick={() => { setConfirmPause(false) }}
			/>
			<Button label={t('subscriber.pause')} icon="pi pi-check" loading={pausingSubscription} id="pause_yes_btn"
				onClick={() => {
					pauseSubscriptions(id, defMembership.id);
					setState((state) => { return { ...state, paused: true } })
				}}
				autoFocus />
		</div>
	);

	const cancelSubscriptionActions = (
		<div className="subs-actions-footer">
			<Button label={t('common.no')} icon="pi pi-times" className="p-button-text" id="cancelSubs_no_btn"
				onClick={() => { setConfirmCancel(false) }}
			/>
			<Button label={t('common.yes')} icon="pi pi-check" loading={cancellingSubscription} id="cancelSubs_yes_btn"
				onClick={() => {
					cancelSubscriptions(id, defMembership.id);
					setState((state) => { return { ...state, cancelled: true, key: true } })
				}}
				autoFocus />
		</div>
	);

	const rescheduleSubscriptionActions = (
		<div className="subs-actions-footer">
			<Button label={t('subscriber.cancel')} icon="pi pi-times" className="p-button-text" id="reschedule_no_btn"
				onClick={() => { setConfirmReschedule(false) }}
			/>
			<Button label={t('subscriber.reschedule')} icon="pi pi-check" loading={reschedulingSubscription} disabled={!date} id="reschedule_confirm_btn"
				onClick={() => {
					rescheduleSubscriptions(id, newDate, defMembership.id);
					setState((state) => { return { ...state, rescheduled: true, key: true } })
				}}
				autoFocus />
		</div>
	);

	const submitReassignPlan = () => {
		const scheduleId = reassignableSchedule?.id;
		const planId = reassignDialog.treePlanSelected?.id;
		if (!scheduleId || !planId || !defMembership?.id) return;
		reassignPaymentSchedulePlan(scheduleId, planId, defMembership.id);
		setReassignRequested(true);
	};

	const submitChangeTarget = () => {
		if (!canSubmitChangeTarget || !id) return;
		changeSubscriptionTarget(id, defMembership.id, parsedNewTarget);
		setChangeTargetRequested(true);
	};

	const reassignPlanActions = (
		<div className="subs-actions-footer">
			<Button label={t('subscriber.cancel')} icon="pi pi-times" className="p-button-text" id="reassign_no_btn"
				onClick={closeReassignDialog}
				disabled={reassigningPaymentSchedulePlan}
			/>
			<Button label={t('subscriber.reassign_plan')} icon="pi pi-check" loading={reassigningPaymentSchedulePlan}
				disabled={!reassignDialog.treePlanSelected?.id || !reassignableSchedule?.id || reassigningPaymentSchedulePlan}
				id="reassign_confirm_btn"
				onClick={submitReassignPlan}
				autoFocus />
		</div>
	);

	const changeTargetActions = (
		<div className="subs-actions-footer">
			<Button label={t('subscriber.cancel')} icon="pi pi-times" className="p-button-text" id="change_target_no_btn"
				onClick={closeChangeTargetDialog}
				disabled={changingSubscriptionTarget}
			/>
			<Button label={t('subscriber.change_target')} icon="pi pi-check" loading={changingSubscriptionTarget}
				disabled={!canSubmitChangeTarget}
				id="change_target_confirm_btn"
				onClick={submitChangeTarget}
				autoFocus />
		</div>
	);

	const calendarDateFormat = defMembership?.business?.country?.jsShortDateFormat;

	return (
		<>
			{loading ? <Loading /> :
				<div className="subscription-detail-page">
					<Toast ref={cancelToast} onRemove={(message) => {
						if (message.severity === 'success') {
							getSubscriber(id)
						}
					}} />
					<Toast ref={resumeToast} onRemove={(message) => {
						if (message.severity === 'success') {
							getSubscriber(id)
						}
					}} />
					<Toast ref={pauseToast} onRemove={(message) => {
						if (message.severity === 'success') {
							getSubscriber(id)
						}
					}} />
					< Toast ref={rescheduleToast}
						onRemove={(message) => {
							if (message.severity === 'success') {
								getSubscriber(id)
								getAllPaymentSchedules(id);
							}
						}} />
					<Toast ref={reassignToast}
						onRemove={(message) => {
							if (message.severity === 'success') {
								refreshSubscriptionDetail();
							}
						}} />
					<Toast ref={changeTargetToast}
						onRemove={(message) => {
							if (message.severity === 'success') {
								refreshSubscriptionDetail();
							}
						}} />
					<DetailCard subscribers={state.subscriberObjects} totalReceivedPayments={state.revenueObject.collected} totalMissedPayments={missedPaymentSchedulesCount}
						defMembership={defMembership} setState={setState} setConfirmPause={setConfirmPause} setConfirmCancel={setConfirmCancel}
						setConfirmResume={setConfirmResume} setConfirmReschedule={setConfirmReschedule} totalDeductions={state.count} subscriptionSummary={subscriptionSummary}
						showTriggerPayment={showTriggerPayment}
						onTriggerPayment={openTriggerPayment}
						showRecordPayment={showRecordPayment}
						onRecordPayment={openRecordPayment}
						showReassignPlan={showReassignPlan}
						onReassignPlan={openReassignPlan}
						showChangeTarget={showChangeTarget}
						onChangeTarget={openChangeTarget}
					/>
					<CollectPayment
						{...{ state, setState, membershipId, countryCurrency, defMembership }}
						callBack={refreshSubscriptionDetail}
					/>
					<RecordPayment
						{...{ state, setState, membershipId, countryCurrency, defMembership }}
						calenderDateFormat={calendarDateFormat}
						callBack={refreshSubscriptionDetail}
					/>
					<Dialog
						className="tier_dialog" id="tier_dialog"
						visible={confirmPause}
						style={{ width: "auto" }}
						onHide={() => setConfirmPause(false)}
						header={t("subscriber.confirmation_header")}
						footer={pauseSubscriptionActions}
					>
						{<h6>{t("subscriber.pause_confirmation_message")}</h6>}
					</Dialog>
					<Dialog
						className="tier_dialog" id="tier_dialog"
						visible={confirmCancel}
						style={{ width: "auto" }}
						onHide={() => setConfirmCancel(false)}
						header={t("subscriber.confirmation_header")}
						footer={cancelSubscriptionActions}
					>
						{<h6>{t("subscriber.cancel_confirmation_message")}</h6>}
					</Dialog>
					<Dialog className="tier_dialog" id="tier_dialog" onHide={() => setConfirmResume(false)} visible={confirmResume} header={t("subscriber.resume_label")} footer={footerContent}>
						{
							<div className="field  reschedule-date" >
								<Calendar
									id="startDate"
									name="startDate"
									value={date}
									minDate={today}
									dateFormat={calendarDateFormat}
									readOnlyInput
									onChange={(e) => setDate(e.value)} showIcon
									placeholder={t("subscriber.resumption_date")}
									className="p-datepicker-header"
								/>
							</div>
						}
					</Dialog>
					<Dialog className="tier_dialog" id="tier_dialog" onHide={() => setConfirmReschedule(false)} visible={confirmReschedule} header={t("subscriber.reschedule_label")} footer={rescheduleSubscriptionActions} style={{ width: "23rem" }}>
						{
							<div className="field  reschedule-date">
								<Calendar
									id="startDate"
									name="startDate"
									value={date}
									minDate={today}
									readOnlyInput
									onChange={(e) => setDate(e.value)} showIcon
									placeholder={t("subscriber.rescheduling_date")}
									className="p-datepicker-header"
								/>
							</div>
						}
					</Dialog>
					<Dialog
						className="tier_dialog"
						id="reassign_plan_dialog"
						onHide={closeReassignDialog}
						visible={confirmReassign}
						header={t("subscriber.reassign_plan")}
						footer={reassignPlanActions}
						style={{ width: "28rem" }}
					>
						{state.subscriberObjects?.plan?.name && (
							<p className="mb-2">{t("subscriber.reassign_plan_current", { name: state.subscriberObjects.plan.name })}</p>
						)}
						<div className="field">
							<TreeSelectComponent
								state={reassignDialog}
								setState={setReassignDialog}
								showClear={true}
								showOneOffOnly={true}
								excludePlanId={state.subscriberObjects?.plan?.id}
								placeholder={t("subscriber.reassign_plan_select")}
								className="w-full"
							/>
						</div>
						{!fetchingAllPaymentSchedules && !reassignableSchedule?.id && (
							<p className="mt-2 mb-0">{t("subscriber.reassign_plan_no_schedule")}</p>
						)}
						{planGroupsGraphedActive && !hasOtherOncePlans && (
							<p className="mt-2 mb-0">{t("subscriber.reassign_plan_no_plans")}</p>
						)}
					</Dialog>
					<Dialog
						className="tier_dialog"
						id="change_target_dialog"
						onHide={closeChangeTargetDialog}
						visible={confirmChangeTarget}
						header={t("subscriber.change_target_header")}
						footer={changeTargetActions}
						style={{ width: "28rem" }}
					>
						<p className="mb-2">
							{t("subscriber.change_target_current")}:{" "}
							<FormatCurrency
								amount={currentTargetAmount}
								currencySymbol={currencySymbol}
								currencyFormat={currencyFormat}
							/>
						</p>
						<p className="mb-2">
							{t("subscriber.change_target_collected")}:{" "}
							<FormatCurrency
								amount={collectedTargetAmount}
								currencySymbol={currencySymbol}
								currencyFormat={currencyFormat}
							/>
						</p>
						<p className="mb-3">{t("subscriber.change_target_hint")}</p>
						<div className="field">
							<label htmlFor="newTarget" className="font-bold block mb-2">
								{t("subscriber.change_target_new")} {defMembership?.business?.currency ? `(${defMembership.business.currency})` : ""}
							</label>
							<InputText
								id="newTarget"
								name="newTarget"
								className="w-full"
								value={newTarget}
								inputMode="decimal"
								autoComplete="off"
								disabled={changingSubscriptionTarget}
								placeholder={t("subscriber.change_target_new")}
								onChange={(e) => {
									const value = e.target.value;
									if (/^\d*\.?\d{0,2}$/.test(value)) {
										setNewTarget(value);
									}
								}}
							/>
							{changeTargetTooLow && (
								<small className="p-error">{t("subscriber.change_target_min_error", { amount: formattedMinTarget })}</small>
							)}
						</div>
						{parsedNewTarget != null && parsedNewTarget === collectedTargetAmount && collectedTargetAmount > 0 && (
							<p className="mt-2 mb-0">{t("subscriber.change_target_complete_hint")}</p>
						)}
					</Dialog>

					{
						loading ? <Loading /> :
							<TransactionsTabs payments={state.paymentTracks} missed={state.missedSchedules} missedSchedulesCount={state.missedSchedulesCount} collectedPaymentsCount={state.count} />
					}
				</div>
			}
		</>
	);
}
export default Subscribers;
